import { events } from '../core/events.js';

// Story flags are sticky booleans — once set, they remain set for the session.
// Used to gate narrative beats so they only fire once.
const flags = new Set();

export function setFlag(name) {
  if (flags.has(name)) return;
  flags.add(name);
  events.emit('flag:set', name);
}

export function hasFlag(name) { return flags.has(name); }
